
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11847',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11847",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.454",
  "dashboard-client-types": "static-1.300",
  "data-fetching-client": "static-1.9557",
  "foundations-components": "static-1.7676",
  "foundations-components-legacy": "static-1.701",
  "foundations-theming": "static-1.4292",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.79",
  "head-dlb": "static-1.4884",
  "hs-test-utils": "static-1.7893",
  "hub-http-shared-msw-handlers": "static-1.9677",
  "hubspot-dlb": "static-2.1806",
  "hubspot-url-utils": "static-1.3957",
  "HubStyleTokens": "static-2.11324",
  "I18n": "static-7.1598",
  "jasmine-runner": "static-1.6351",
  "marketplace-storefront-base": "static-1.11908",
  "quartz": "static-1.6839",
  "react-dlb": "static-1.74",
  "react-rhumb": "static-1.16534",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2744",
  "reporting-testing-lib": "static-1.8838",
  "settings-ui-lib": "static-1.12406",
  "SharedI18nStrings": "static-1.181",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6905",
  "ui-addon-i18n": "static-1.11027",
  "ui-addon-react-router-dom": "static-1.9426",
  "unified-auth": "static-1.318",
  "unified-auth-core-lib": "static-1.599",
  "usage-tracker": "static-1.7217",
  "usage-tracker-core": "static-1.7067",
  "customer-data-property-utils": "static-1.7963",
  "history": "static-4.47",
  "hub-http": "static-1.6100",
  "integrations-lib": "static-1.15696",
  "marketplace-ui-common": "static-1.19214",
  "property-management-iframe": "static-1.12714",
  "quartz-config": "static-1.617",
  "quartz-core": "static-1.6058",
  "quartz-routing": "static-1.269",
  "quick-fetch": "static-1.3815",
  "react": "static-7.182",
  "rpc-client-utils": "static-1.4524",
  "ts-schema": "static-1.3981",
  "ui-universal-auth": "static-1.8804",
  "UIComponents": "static-3.8271",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.416",
  "hs-promise-rejection-tracking": "static-1.5433",
  "PortalIdParser": "static-2.377",
  "raven": "static-3.5768",
  "raven-hubspot": "static-1.6075",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9436",
  "react-redux": "static-7.67",
  "redux": "static-4.16",
  "styled-components": "static-2.85",
  "bend-plugin-trellis-migration": "static-1.3308",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3116",
  "quartz-webpack": "static-1.3063",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3945",
  "floating-ui": "static-1.53",
  "foundations-assets": "static-1.4721",
  "foundations-theming-specialty": "static-1.2008",
  "framer-motion": "static-1.69",
  "hs-story-utils": "static-1.9309",
  "react-aria": "static-1.63",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5249",
  "react-virtualized": "static-2.96",
  "StyleGuideUI": "static-3.485",
  "tanstack-table": "static-1.52",
  "trellis-assets": "static-1.1455",
  "ui-fonts": "static-1.586",
  "ui-images": "static-2.1124",
  "bend-plugin-foundations-theming": "static-1.2775",
  "foundations-theming-base": "static-1.3277",
  "stylex": "static-1.29",
  "HeadJS": "static-2.732",
  "hs-test-utils-bend-plugin": "static-1.3004",
  "msw": "static-1.39",
  "testing-library": "static-1.149",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.218",
  "moment-timezone": "static-5.80",
  "jasmine": "static-4.4206",
  "ai-components-ui-library": "static-1.8608",
  "ai-rendering-library": "static-1.9614",
  "chirp-fetch": "static-1.1763",
  "connections-embed-lib": "static-1.750",
  "copilot-toolkit": "static-1.10770",
  "laboratory-lib": "static-3.7041",
  "marketplace-embed": "static-1.21713",
  "marketplace-ui-details": "static-1.9110",
  "marketplace-ui-reviews": "static-1.19170",
  "marketplace-ui-tracking": "static-1.13385",
  "sanitize-text": "static-1.8026",
  "ui-addon-video-player": "static-1.8575",
  "usage-tracker-multi": "static-1.5631",
  "usage-tracker-session-replay": "static-1.4903",
  "wootric-nps": "static-1.6865",
  "apollo-link-hub-http": "static-2.4532",
  "immer": "static-1.33",
  "immerable": "static-1.4034",
  "highcharts": "static-8.101",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2422",
  "reporting-data": "static-1.66905",
  "cssUtils": "static-1.764",
  "flux-actions": "static-1.323",
  "HubStyle": "static-2.11632",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10091",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10255",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7207",
  "icons": "static-2.637",
  "marketplace-ui-apps-core": "static-1.17747",
  "storybook-react": "static-1.30",
  "trellis-story-utils": "static-1.4401",
  "foundations-components-test-utils": "static-1.5159",
  "quartz-i18n": "static-1.514",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3612",
  "customer-data-objects": "static-1.7535",
  "property-translator": "static-1.5290",
  "frontend-preferences-client": "static-1.7805",
  "hs-promise-utils": "static-1.5476",
  "hubspot-apollo-client": "static-1.4760",
  "integrations-error-boundary-lib": "static-1.13111",
  "integrations-tracking-lib": "static-1.5475",
  "native-integrations-shared-strings": "static-1.7668",
  "reselect": "static-2.16",
  "sanitize": "static-1.4354",
  "superstore": "static-1.4649",
  "ui-shepherd-react": "static-3.10027",
  "ai-settings-ui-library": "static-1.7684",
  "hub-http-janus": "static-1.816",
  "hubspotter-http": "static-1.4554",
  "immutable-less": "static-1.4534",
  "marketplace-ui-client-types": "static-1.16621",
  "nav-meta": "static-1.29207",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10126",
  "ui-addon-upgrades": "static-9.17797",
  "inbound-db-properties-service-client": "static-1.3747",
  "property-management-common": "static-1.5002",
  "ui-addon-iframeable": "static-1.8931",
  "dispatcher": "static-1.133",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.506",
  "module-federation": "static-1.20",
  "quartz-auth": "static-1.514",
  "quartz-head": "static-1.504",
  "quartz-test": "static-1.514",
  "quartz-tracking": "static-1.218",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.3041",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20718",
  "ContentUtils": "static-1.67904",
  "sassPrefix": "static-1.153",
  "avatar-components": "static-1.2374",
  "customer-data-filters-ui": "static-1.39235",
  "customer-data-objects-ui-components": "static-1.12897",
  "customer-data-reference-ui-components": "static-1.13032",
  "embedded-academy-lib": "static-1.13860",
  "ExportDialog": "static-6.10269",
  "highlight.js": "static-1.76",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40895",
  "reporting-snowflake": "static-1.55523",
  "reporting-ui-components": "static-2.64176",
  "reporting-visualizations": "static-1.58981",
  "ui-addon-teams": "static-1.21373",
  "magpie-lib": "static-1.5475",
  "magpie-types": "static-1.4935",
  "simple-logging-lib": "static-1.2931",
  "navigation-components": "static-1.17570",
  "ai-studio-lib": "static-1.11239",
  "app-governance-lib": "static-1.1152",
  "developer-experience-shared-components": "static-1.10384",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7872",
  "ui-product-approvals": "static-1.27756",
  "ui-tool-access": "static-1.10026",
  "usage-based-billing-components-lib": "static-1.8252",
  "usage-tracker-anonymous": "static-1.5634",
  "usage-tracker-public": "static-1.7028",
  "amplitude-session-replay-browser": "static-1.57",
  "inbound-db-meta-service-client": "static-1.3491",
  "persist-promise": "static-1.3590",
  "reference-resolvers": "static-1.8047",
  "ui-extensibility-client-types": "static-1.3822",
  "hubspot-apollo-cache": "static-1.219",
  "universal-page-editor-lib": "static-1.2886",
  "final-form": "static-1.67",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2420",
  "merchandise-lib": "static-1.261",
  "atom": "static-1.4951",
  "purchase-motions-components": "static-1.5638",
  "salesImages": "static-1.522",
  "batch-promise": "static-1.1433",
  "crm-component-utils": "static-1.38716",
  "crm-properties-common-lib": "static-1.5756",
  "customer-data-properties": "static-1.51083",
  "framework-data-schema-resolvers": "static-1.6756",
  "property-value-citations": "static-1.1697",
  "reference-resolvers-lite": "static-1.7970",
  "navigation-messaging": "static-1.6897",
  "hubspotter-http-shared-msw-handlers": "static-1.9675",
  "cms-field-types": "static-1.4689",
  "content-icons-ui": "static-1.2188",
  "conversations-skeleton-state": "static-1.7130",
  "crm-message-bus": "static-1.42635",
  "customer-data-filters-ui-msw-helpers": "static-1.21670",
  "customer-data-ui-utilities": "static-1.9705",
  "FormUrlGenerator": "static-2.4601",
  "framework-builder-read-service-client": "static-1.3910",
  "framework-data-schema-quick-fetch": "static-1.6661",
  "multi-account-reference-resolvers": "static-1.864",
  "onboarding-tours": "static-1.16380",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13310",
  "academy-common-lib": "static-1.13320",
  "content-assistance-lib": "static-1.7567",
  "dashboard-lib": "static-1.80993",
  "file-manager-components": "static-1.23202",
  "getting-started-shared-tasks": "static-1.18133",
  "hubspot-prosemirror": "static-1.17865",
  "hubspot-prosemirror-plugins": "static-1.17857",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19619",
  "share-with-third-party-component-lib": "static-1.8574",
  "ui-addon-draggable": "static-3.4649",
  "ui-asset-management-lib": "static-1.10840",
  "ui-business-units-lib": "static-1.8918",
  "user-context": "static-1.4981",
  "growth-payments-core": "static-1.24984",
  "reporting-plugins": "static-1.10100",
  "reporting-reports": "static-1.66583",
  "idb-keyval": "static-1.41",
  "reactive-lib": "static-1.605",
  "nest": "static-1.103",
  "codemirror": "static-5.92",
  "feedback-loader": "static-1.29049",
  "react-codemirror": "static-1.10505",
  "framework-listing-lib": "static-2.28293",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.30369",
  "apps-service-types": "static-1.3758",
  "oauth-service-types": "static-1.4128",
  "onboarding-scopes": "static-1.6344",
  "onboarding-tours-client": "static-1.4594",
  "platform-infra-nav-components": "static-1.7568",
  "subscription-experience-data-types": "static-1.14696",
  "crm-record-cards-service-types": "static-1.3513",
  "location-customization-utils-lib": "static-1.8840",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4379",
  "nav-client-types": "static-1.2238",
  "purchase-motions-api": "static-1.5641",
  "signup-constants": "static-1.18602",
  "signup-ui-url-generator": "static-2.7916",
  "trials-service-types": "static-1.3780",
  "card-properties-lib": "static-1.43784",
  "commerce-subscription-lib": "static-1.36724",
  "crm-actions": "static-1.6194",
  "crm-cards-sdk": "static-1.43191",
  "customer-data-properties-shared-msw-handlers": "static-1.9004",
  "customer-data-tracking": "static-1.6764",
  "hs-resources": "static-1.15",
  "pulse": "static-1.414",
  "calling-global-api": "static-1.64015",
  "calling-internal-common": "static-1.31182",
  "calling-lifecycle-internal": "static-1.65397",
  "calling-lifecycle-messages": "static-1.57691",
  "commerce-products-lib": "static-1.9085",
  "conditional-properties-service-client": "static-1.3699",
  "crm-links": "static-1.6154",
  "external-options-client-types": "static-1.4060",
  "google-libphonenumber": "static-1.35",
  "inbounddb-objects-service-types": "static-1.4124",
  "meetings-icalendar-utils-lib": "static-1.512",
  "multi-currency-client-types": "static-1.3591",
  "object-builder-ui-client": "static-1.48312",
  "pipeline-validation-client-types": "static-1.3865",
  "smart-property-lib": "static-1.6315",
  "tiered-pricing": "static-1.972",
  "ui-addon-form-validation": "static-1.10873",
  "crm-pipelines-api-client-types": "static-1.4044",
  "react-dnd-compat": "static-1.4500",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5242",
  "growth-onboarding-confetti": "static-1.2953",
  "growth-onboarding-next-action-utils": "static-1.1540",
  "onboarding-tours-utils": "static-1.446",
  "ui-shepherd-tracker": "static-1.7408",
  "academy-service-client": "static-1.3561",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.28180",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8264",
  "video-components-external": "static-1.10848",
  "video-data-lib": "static-1.34506",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8438",
  "payment-link-components": "static-1.23171",
  "ui-addon-emoji-picker": "static-1.9768",
  "EmailSignatureEditor": "static-1.24084",
  "viral-links-lib": "static-1.6921",
  "data-token-picker": "static-1.16190",
  "FileManagerLib": "static-1.38842",
  "react-flip-move": "static-1.67",
  "timezone-utils": "static-2.5125",
  "getting-started-shared-tasks-store": "static-1.17251",
  "campaign-roi-lib": "static-1.8555",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "customer-data-associations": "static-1.7204",
  "customer-data-views-management": "static-1.25168",
  "framework-data-table": "static-2.11608",
  "marketing-platform-lib": "static-1.6730",
  "nudge-client-utils": "static-1.2317",
  "nudge-custom-ui-functions": "static-1.815",
  "app-users-service-client": "static-1.5433",
  "app-users-service-types": "static-1.4841",
  "mini-checkout-client": "static-1.26516",
  "onboarding-utils": "static-1.5231",
  "permissions-shared-i18n-strings-fe": "static-1.1992",
  "ui-coaching-tips-shared-config": "static-1.28165",
  "edison-service-client-types": "static-1.267",
  "eligibility-engine-service-types": "static-1.3061",
  "crm_data": "static-4.91540",
  "customer-data-sidebar": "static-2.45653",
  "enrichment-properties-lib": "static-1.15433",
  "commerce-billing-lib": "static-1.18728",
  "commerce-shared-components-lib": "static-1.18188",
  "commerce-tools-ui-lib": "static-1.10030",
  "crm-fe-perf": "static-1.22784",
  "directed-graph": "static-1.819",
  "event-emitter": "static-1.828",
  "fast-json-patch": "static-1.60",
  "calling-error-reporting": "static-1.31188",
  "shared-worker-versioning": "static-1.10920",
  "calling-usage-tracker": "static-1.6423",
  "voice-sms-access-library": "static-1.514",
  "commerce-permissions": "static-1.645",
  "products-iframe-lib": "static-1.7573",
  "products-ui-components-shared-msw-handlers": "static-1.10059",
  "breeze-intelligence-kit": "static-1.5440",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9760",
  "policy-lib": "static-1.6660",
  "react-tinymce": "static-1.54875",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9823",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.54001",
  "tinymce-plugins": "static-1.57115",
  "tinymce-themes": "static-1.55971",
  "growth-onboarding-next-action-components": "static-1.1568",
  "user-context-client": "static-1.4493",
  "growth-onboarding-feedback-components": "static-1.6462",
  "content-media-composition-data-lib": "static-1.11808",
  "content-media-compositions": "static-2.15815",
  "media-bridge-lib": "static-1.18710",
  "commerce-tours-lib": "static-1.5865",
  "growth-onboarding-reliability": "static-1.4968",
  "sales-checkout-service-client": "static-1.3549",
  "draft-convert": "static-2.70",
  "draft-extend": "static-3.72",
  "draft-js": "static-5.75",
  "draft-plugins": "static-2.21457",
  "sales-email-signature-service-client": "static-1.3724",
  "audio-components": "static-1.5730",
  "FileManagerCore": "static-1.38701",
  "FileManagerImages": "static-1.36353",
  "video-components": "static-1.12851",
  "crm-export-dialog": "static-1.6174",
  "crm-index-associations-lib": "static-1.6317",
  "react-beautiful-dnd": "static-1.13",
  "deal-intel-decorators": "static-1.1562",
  "tanstack-virtual": "static-1.27",
  "nudge-custom-function-registry": "static-1.2074",
  "nudge-renderer-utils": "static-1.2393",
  "whisper-core-api": "static-1.6239",
  "InboxConnectUtils": "static-4.14457",
  "emoji-regex": "static-1.7",
  "touchless-buying-components": "static-1.5250",
  "settings-content-modals": "static-1.45710",
  "crm_universal": "static-1.21791",
  "customer-data-email": "static-1.17819",
  "card-payment-highlight-lib": "static-1.36769",
  "card-subscription-highlight-lib": "static-1.39147",
  "commerce-contract-lib": "static-1.11513",
  "invoices-highlight-card-lib": "static-1.54288",
  "orders-highlight-card-lib": "static-1.21100",
  "products-highlight-card-lib": "static-1.17369",
  "quotes-highlight-card-lib": "static-1.71501",
  "crm-source-interpretation-lib": "static-1.5213",
  "utility-belt": "static-1.2421",
  "payments-enrollment-embed-lib": "static-1.22261",
  "stripe-embedded-components": "static-1.7288",
  "customer-data-rte": "static-1.32663",
  "cv-backend-services": "static-1.1531",
  "growth-onboarding-empty-states": "static-1.5491",
  "payments-post-enroll-local-storage-lib": "static-1.4993",
  "qrcode-generator": "static-1.66",
  "quotes-client-types": "static-1.37591",
  "calling-orchestration-schema": "static-1.35291",
  "sales-views-client-types": "static-1.4144",
  "hub-http-contrib": "static-1.2924",
  "interframe": "static-3.4643",
  "tinymce-data": "static-1.40086",
  "ui-addon-sales-email": "static-1.5093",
  "layout-dnd-components": "static-1.12205",
  "layout-dnd-utils": "static-1.11180",
  "ui-brand-identity-lib": "static-1.14538",
  "NamespacedHubStyle": "static-2.8970",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4413",
  "video-embed": "static-1.35340",
  "social-insights-client-types": "static-1.21686",
  "deal-intel-utils": "static-1.1566",
  "checkout-sdk": "static-3.23359",
  "checkout-service-types": "static-1.3727",
  "company-details-components": "static-1.6067",
  "payment-method-components": "static-1.6778",
  "pricing-pages-ui-components": "static-1.13113",
  "quote-checkout-service-types": "static-1.3362",
  "upgrade-catalog-service-types": "static-1.3407",
  "access-control-lib": "static-1.10318",
  "EmailComponents": "static-1.54391",
  "EmailData": "static-1.53068",
  "redux-less": "static-2.9366",
  "sequences-lib": "static-1.7830",
  "ui-gdpr-components": "static-1.10229",
  "products-ui-components": "static-1.39604",
  "quotes-ui-lib": "static-1.80222",
  "accounting-integrations-ui-components": "static-1.6864",
  "invoices-ui-lib": "static-1.54304",
  "commerce-products-api": "static-1.2098",
  "invoices-iframe-lib": "static-1.56362",
  "quotes-modal-lib": "static-1.102179",
  "stripe-connect-js": "static-1.66",
  "draft-content-plugins": "static-1.27932",
  "ContentData": "static-1.67979",
  "layout-data-lib": "static-1.9505",
  "outpost": "static-1.4079",
  "hub-http-rxjs": "static-1.782",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "company-details-service-types": "static-1.3810",
  "billing-payments-client-types": "static-1.3869",
  "account-and-billing-fintech-outages": "static-3.18350",
  "pricing-pages-api": "static-1.12978",
  "ContentComponents": "static-2.70860",
  "marketing-contacts-lib": "static-1.9426",
  "marketing-email-service-types": "static-1.1831",
  "messaging-editing-lib": "static-1.45872",
  "messaging-usage-based-billing-components-lib": "static-1.734",
  "automation-ui-source-apps": "static-1.18481",
  "automation-ui-types": "static-1.19399",
  "messaging-types-lib": "static-1.45609",
  "onboarding-settings-client": "static-1.4385",
  "sequences-client-types-lib": "static-1.7687",
  "commerce-tax-lib": "static-1.399",
  "property-description-translator": "static-1.3735",
  "SalesContentIndexUI": "static-3.9042",
  "commerce-analytics-service-client": "static-1.3537",
  "totals-ui-components": "static-1.23219",
  "advanced-menus-core": "static-1.14937",
  "advanced-menus-lib": "static-1.11903",
  "ui-memberships-settings-lib": "static-1.33688",
  "demographics-service-types": "static-1.1529",
  "automation-ui-ubb": "static-1.5315",
  "blueimp-md5": "static-1.8",
  "content-embed-lib": "static-1.7221",
  "data-token-views": "static-1.16171",
  "forms-utils-lib": "static-1.12343",
  "payments-embed-points-lib": "static-1.12783",
  "simple-menus-core": "static-1.14936",
  "simple-menus-lib": "static-1.16453",
  "ui-addon-draggable-compat": "static-2.4135",
  "videoconference-integration-components": "static-1.6645",
  "automation-applications-service-types": "static-1.3400",
  "automation-platform-service-types": "static-1.2545",
  "ContentEditorUI": "static-2.76756",
  "short-messages-app-service-client": "static-1.3867",
  "web-interactives-components": "static-1.13550",
  "web-interactives-data": "static-1.13551",
  "messaging-shared-utils-lib": "static-1.183",
  "messaging-user-info-utils-lib": "static-1.353",
  "email-portal-health-service-types": "static-1.857",
  "FireAlarmUi": "static-1.4410",
  "sales-templates-service-types-lib": "static-1.4068",
  "commerce-totals-service-types": "static-1.3717",
  "seamless-immutable": "static-7.6",
  "automation-ui-core": "static-2.21335",
  "automation-ui-usage-tracking": "static-1.20798",
  "data-studio-ubb": "static-1.2354",
  "backbone": "static-1.6",
  "campaigns-lib": "static-1.26655",
  "collaboration-sidebar": "static-1.57391",
  "content-management-data-lib": "static-1.5229",
  "copilot-plugins": "static-1.10743",
  "cta-picker": "static-1.36064",
  "customer-agent-discovery-components-lib": "static-1.2686",
  "editor-components": "static-1.13053",
  "editor-iframe-lib": "static-1.8233",
  "error-messaging-js": "static-1.5071",
  "FormsCommonComponents": "static-1.85512",
  "pictos": "static-7.181",
  "react-transition-group": "static-2.62",
  "redux-request-state": "static-1.10526",
  "SharedLegalStrings": "static-1.1633",
  "smart-content-core": "static-1.42092",
  "smart-content-lib": "static-1.42745",
  "social-composer-lib": "static-1.58477",
  "structured-content-lib": "static-1.24848",
  "theme-previewer-lib": "static-1.52900",
  "tinymce-copilot": "static-1.16069",
  "xray-recommendation-lib": "static-1.7721",
  "automation-ui-routing": "static-1.20756",
  "sql-reporting-client-types": "static-1.5545",
  "jquery": "static-3.6",
  "attribution-lib": "static-1.41868",
  "campaigns-utils-lib": "static-1.3038",
  "reporting-enablement": "static-1.22406",
  "chatspot-widget-iframe": "static-1.20710",
  "collaboration-sidebar-common": "static-1.2188",
  "forms-ai-lib": "static-1.4127",
  "codemirror-dlb": "static-1.58315",
  "redux-mock-store": "static-1.8",
  "redux-undo": "static-1.10",
  "seo-tools-lib": "static-1.6309",
  "report-customization-components": "static-1.12768",
  "data-quality-ui-library": "static-1.12537",
  "html-to-image": "static-1.51",
  "reporting-insights-lib": "static-1.1334"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11847",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.454",
  "dashboard-client-types": "/dashboard-client-types/static-1.300",
  "data-fetching-client": "/data-fetching-client/static-1.9557",
  "foundations-components": "/foundations-components/static-1.7676",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.701",
  "foundations-theming": "/foundations-theming/static-1.4292",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.79",
  "head-dlb": "/head-dlb/static-1.4884",
  "hs-test-utils": "/hs-test-utils/static-1.7893",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9677",
  "hubspot-dlb": "/hubspot-dlb/static-2.1806",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3957",
  "HubStyleTokens": "/HubStyleTokens/static-2.11324",
  "I18n": "/I18n/static-7.1598",
  "jasmine-runner": "/jasmine-runner/static-1.6351",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11908",
  "quartz": "/quartz/static-1.6839",
  "react-dlb": "/react-dlb/static-1.74",
  "react-rhumb": "/react-rhumb/static-1.16534",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2744",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8838",
  "settings-ui-lib": "/settings-ui-lib/static-1.12406",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.181",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6905",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11027",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9426",
  "unified-auth": "/unified-auth/static-1.318",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.599",
  "usage-tracker": "/usage-tracker/static-1.7217",
  "usage-tracker-core": "/usage-tracker-core/static-1.7067",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7963",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.6100",
  "integrations-lib": "/integrations-lib/static-1.15696",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.19214",
  "property-management-iframe": "/property-management-iframe/static-1.12714",
  "quartz-config": "/quartz-config/static-1.617",
  "quartz-core": "/quartz-core/static-1.6058",
  "quartz-routing": "/quartz-routing/static-1.269",
  "quick-fetch": "/quick-fetch/static-1.3815",
  "react": "/react/static-7.182",
  "rpc-client-utils": "/rpc-client-utils/static-1.4524",
  "ts-schema": "/ts-schema/static-1.3981",
  "ui-universal-auth": "/ui-universal-auth/static-1.8804",
  "UIComponents": "/UIComponents/static-3.8271",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.416",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5433",
  "PortalIdParser": "/PortalIdParser/static-2.377",
  "raven": "/raven/static-3.5768",
  "raven-hubspot": "/raven-hubspot/static-1.6075",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9436",
  "react-redux": "/react-redux/static-7.67",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.85",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3308",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3116",
  "quartz-webpack": "/quartz-webpack/static-1.3063",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3945",
  "floating-ui": "/floating-ui/static-1.53",
  "foundations-assets": "/foundations-assets/static-1.4721",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2008",
  "framer-motion": "/framer-motion/static-1.69",
  "hs-story-utils": "/hs-story-utils/static-1.9309",
  "react-aria": "/react-aria/static-1.63",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5249",
  "react-virtualized": "/react-virtualized/static-2.96",
  "StyleGuideUI": "/StyleGuideUI/static-3.485",
  "tanstack-table": "/tanstack-table/static-1.52",
  "trellis-assets": "/trellis-assets/static-1.1455",
  "ui-fonts": "/ui-fonts/static-1.586",
  "ui-images": "/ui-images/static-2.1124",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2775",
  "foundations-theming-base": "/foundations-theming-base/static-1.3277",
  "stylex": "/stylex/static-1.29",
  "HeadJS": "/HeadJS/static-2.732",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3004",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.149",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.218",
  "moment-timezone": "/moment-timezone/static-5.80",
  "jasmine": "/jasmine/static-4.4206",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8608",
  "ai-rendering-library": "/ai-rendering-library/static-1.9614",
  "chirp-fetch": "/chirp-fetch/static-1.1763",
  "connections-embed-lib": "/connections-embed-lib/static-1.750",
  "copilot-toolkit": "/copilot-toolkit/static-1.10770",
  "laboratory-lib": "/laboratory-lib/static-3.7041",
  "marketplace-embed": "/marketplace-embed/static-1.21713",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.9110",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.19170",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13385",
  "sanitize-text": "/sanitize-text/static-1.8026",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8575",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5631",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4903",
  "wootric-nps": "/wootric-nps/static-1.6865",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4532",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.4034",
  "highcharts": "/highcharts/static-8.101",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2422",
  "reporting-data": "/reporting-data/static-1.66905",
  "cssUtils": "/cssUtils/static-1.764",
  "flux-actions": "/flux-actions/static-1.323",
  "HubStyle": "/HubStyle/static-2.11632",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10091",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10255",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7207",
  "icons": "/icons/static-2.637",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17747",
  "storybook-react": "/storybook-react/static-1.30",
  "trellis-story-utils": "/trellis-story-utils/static-1.4401",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5159",
  "quartz-i18n": "/quartz-i18n/static-1.514",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3612",
  "customer-data-objects": "/customer-data-objects/static-1.7535",
  "property-translator": "/property-translator/static-1.5290",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7805",
  "hs-promise-utils": "/hs-promise-utils/static-1.5476",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4760",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13111",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5475",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7668",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4354",
  "superstore": "/superstore/static-1.4649",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10027",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7684",
  "hub-http-janus": "/hub-http-janus/static-1.816",
  "hubspotter-http": "/hubspotter-http/static-1.4554",
  "immutable-less": "/immutable-less/static-1.4534",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16621",
  "nav-meta": "/nav-meta/static-1.29207",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10126",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17797",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3747",
  "property-management-common": "/property-management-common/static-1.5002",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8931",
  "dispatcher": "/dispatcher/static-1.133",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.506",
  "module-federation": "/module-federation/static-1.20",
  "quartz-auth": "/quartz-auth/static-1.514",
  "quartz-head": "/quartz-head/static-1.504",
  "quartz-test": "/quartz-test/static-1.514",
  "quartz-tracking": "/quartz-tracking/static-1.218",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.3041",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20718",
  "ContentUtils": "/ContentUtils/static-1.67904",
  "sassPrefix": "/sassPrefix/static-1.153",
  "avatar-components": "/avatar-components/static-1.2374",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39235",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12897",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13032",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13860",
  "ExportDialog": "/ExportDialog/static-6.10269",
  "highlight.js": "/highlight.js/static-1.76",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40895",
  "reporting-snowflake": "/reporting-snowflake/static-1.55523",
  "reporting-ui-components": "/reporting-ui-components/static-2.64176",
  "reporting-visualizations": "/reporting-visualizations/static-1.58981",
  "ui-addon-teams": "/ui-addon-teams/static-1.21373",
  "magpie-lib": "/magpie-lib/static-1.5475",
  "magpie-types": "/magpie-types/static-1.4935",
  "simple-logging-lib": "/simple-logging-lib/static-1.2931",
  "navigation-components": "/navigation-components/static-1.17570",
  "ai-studio-lib": "/ai-studio-lib/static-1.11239",
  "app-governance-lib": "/app-governance-lib/static-1.1152",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10384",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7872",
  "ui-product-approvals": "/ui-product-approvals/static-1.27756",
  "ui-tool-access": "/ui-tool-access/static-1.10026",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.8252",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5634",
  "usage-tracker-public": "/usage-tracker-public/static-1.7028",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.57",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3491",
  "persist-promise": "/persist-promise/static-1.3590",
  "reference-resolvers": "/reference-resolvers/static-1.8047",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3822",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.219",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2886",
  "final-form": "/final-form/static-1.67",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2420",
  "merchandise-lib": "/merchandise-lib/static-1.261",
  "atom": "/atom/static-1.4951",
  "purchase-motions-components": "/purchase-motions-components/static-1.5638",
  "salesImages": "/salesImages/static-1.522",
  "batch-promise": "/batch-promise/static-1.1433",
  "crm-component-utils": "/crm-component-utils/static-1.38716",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5756",
  "customer-data-properties": "/customer-data-properties/static-1.51083",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6756",
  "property-value-citations": "/property-value-citations/static-1.1697",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7970",
  "navigation-messaging": "/navigation-messaging/static-1.6897",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9675",
  "cms-field-types": "/cms-field-types/static-1.4689",
  "content-icons-ui": "/content-icons-ui/static-1.2188",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7130",
  "crm-message-bus": "/crm-message-bus/static-1.42635",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21670",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9705",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4601",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3910",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6661",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.864",
  "onboarding-tours": "/onboarding-tours/static-1.16380",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13310",
  "academy-common-lib": "/academy-common-lib/static-1.13320",
  "content-assistance-lib": "/content-assistance-lib/static-1.7567",
  "dashboard-lib": "/dashboard-lib/static-1.80993",
  "file-manager-components": "/file-manager-components/static-1.23202",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18133",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17865",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17857",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19619",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8574",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4649",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10840",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8918",
  "user-context": "/user-context/static-1.4981",
  "growth-payments-core": "/growth-payments-core/static-1.24984",
  "reporting-plugins": "/reporting-plugins/static-1.10100",
  "reporting-reports": "/reporting-reports/static-1.66583",
  "idb-keyval": "/idb-keyval/static-1.41",
  "reactive-lib": "/reactive-lib/static-1.605",
  "nest": "/nest/static-1.103",
  "codemirror": "/codemirror/static-5.92",
  "feedback-loader": "/feedback-loader/static-1.29049",
  "react-codemirror": "/react-codemirror/static-1.10505",
  "framework-listing-lib": "/framework-listing-lib/static-2.28293",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.30369",
  "apps-service-types": "/apps-service-types/static-1.3758",
  "oauth-service-types": "/oauth-service-types/static-1.4128",
  "onboarding-scopes": "/onboarding-scopes/static-1.6344",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4594",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7568",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14696",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3513",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8840",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4379",
  "nav-client-types": "/nav-client-types/static-1.2238",
  "purchase-motions-api": "/purchase-motions-api/static-1.5641",
  "signup-constants": "/signup-constants/static-1.18602",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7916",
  "trials-service-types": "/trials-service-types/static-1.3780",
  "card-properties-lib": "/card-properties-lib/static-1.43784",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36724",
  "crm-actions": "/crm-actions/static-1.6194",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.43191",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9004",
  "customer-data-tracking": "/customer-data-tracking/static-1.6764",
  "hs-resources": "/hs-resources/static-1.15",
  "pulse": "/pulse/static-1.414",
  "calling-global-api": "/calling-global-api/static-1.64015",
  "calling-internal-common": "/calling-internal-common/static-1.31182",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65397",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57691",
  "commerce-products-lib": "/commerce-products-lib/static-1.9085",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3699",
  "crm-links": "/crm-links/static-1.6154",
  "external-options-client-types": "/external-options-client-types/static-1.4060",
  "google-libphonenumber": "/google-libphonenumber/static-1.35",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4124",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.512",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3591",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48312",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3865",
  "smart-property-lib": "/smart-property-lib/static-1.6315",
  "tiered-pricing": "/tiered-pricing/static-1.972",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10873",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4044",
  "react-dnd-compat": "/react-dnd-compat/static-1.4500",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5242",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2953",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1540",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.446",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7408",
  "academy-service-client": "/academy-service-client/static-1.3561",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28180",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8264",
  "video-components-external": "/video-components-external/static-1.10848",
  "video-data-lib": "/video-data-lib/static-1.34506",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8438",
  "payment-link-components": "/payment-link-components/static-1.23171",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9768",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24084",
  "viral-links-lib": "/viral-links-lib/static-1.6921",
  "data-token-picker": "/data-token-picker/static-1.16190",
  "FileManagerLib": "/FileManagerLib/static-1.38842",
  "react-flip-move": "/react-flip-move/static-1.67",
  "timezone-utils": "/timezone-utils/static-2.5125",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17251",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8555",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "customer-data-associations": "/customer-data-associations/static-1.7204",
  "customer-data-views-management": "/customer-data-views-management/static-1.25168",
  "framework-data-table": "/framework-data-table/static-2.11608",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.6730",
  "nudge-client-utils": "/nudge-client-utils/static-1.2317",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.815",
  "app-users-service-client": "/app-users-service-client/static-1.5433",
  "app-users-service-types": "/app-users-service-types/static-1.4841",
  "mini-checkout-client": "/mini-checkout-client/static-1.26516",
  "onboarding-utils": "/onboarding-utils/static-1.5231",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.1992",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.28165",
  "edison-service-client-types": "/edison-service-client-types/static-1.267",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.3061",
  "crm_data": "/crm_data/static-4.91540",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45653",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15433",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18728",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.18188",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.10030",
  "crm-fe-perf": "/crm-fe-perf/static-1.22784",
  "directed-graph": "/directed-graph/static-1.819",
  "event-emitter": "/event-emitter/static-1.828",
  "fast-json-patch": "/fast-json-patch/static-1.60",
  "calling-error-reporting": "/calling-error-reporting/static-1.31188",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10920",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6423",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.514",
  "commerce-permissions": "/commerce-permissions/static-1.645",
  "products-iframe-lib": "/products-iframe-lib/static-1.7573",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10059",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5440",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9760",
  "policy-lib": "/policy-lib/static-1.6660",
  "react-tinymce": "/react-tinymce/static-1.54875",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9823",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.54001",
  "tinymce-plugins": "/tinymce-plugins/static-1.57115",
  "tinymce-themes": "/tinymce-themes/static-1.55971",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1568",
  "user-context-client": "/user-context-client/static-1.4493",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6462",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11808",
  "content-media-compositions": "/content-media-compositions/static-2.15815",
  "media-bridge-lib": "/media-bridge-lib/static-1.18710",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5865",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4968",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3549",
  "draft-convert": "/draft-convert/static-2.70",
  "draft-extend": "/draft-extend/static-3.72",
  "draft-js": "/draft-js/static-5.75",
  "draft-plugins": "/draft-plugins/static-2.21457",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3724",
  "audio-components": "/audio-components/static-1.5730",
  "FileManagerCore": "/FileManagerCore/static-1.38701",
  "FileManagerImages": "/FileManagerImages/static-1.36353",
  "video-components": "/video-components/static-1.12851",
  "crm-export-dialog": "/crm-export-dialog/static-1.6174",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6317",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.13",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1562",
  "tanstack-virtual": "/tanstack-virtual/static-1.27",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.2074",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.2393",
  "whisper-core-api": "/whisper-core-api/static-1.6239",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14457",
  "emoji-regex": "/emoji-regex/static-1.7",
  "touchless-buying-components": "/touchless-buying-components/static-1.5250",
  "settings-content-modals": "/settings-content-modals/static-1.45710",
  "crm_universal": "/crm_universal/static-1.21791",
  "customer-data-email": "/customer-data-email/static-1.17819",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36769",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.39147",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11513",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54288",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.21100",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17369",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71501",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5213",
  "utility-belt": "/utility-belt/static-1.2421",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22261",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7288",
  "customer-data-rte": "/customer-data-rte/static-1.32663",
  "cv-backend-services": "/cv-backend-services/static-1.1531",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5491",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4993",
  "qrcode-generator": "/qrcode-generator/static-1.66",
  "quotes-client-types": "/quotes-client-types/static-1.37591",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35291",
  "sales-views-client-types": "/sales-views-client-types/static-1.4144",
  "hub-http-contrib": "/hub-http-contrib/static-1.2924",
  "interframe": "/interframe/static-3.4643",
  "tinymce-data": "/tinymce-data/static-1.40086",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5093",
  "layout-dnd-components": "/layout-dnd-components/static-1.12205",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11180",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14538",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8970",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4413",
  "video-embed": "/video-embed/static-1.35340",
  "social-insights-client-types": "/social-insights-client-types/static-1.21686",
  "deal-intel-utils": "/deal-intel-utils/static-1.1566",
  "checkout-sdk": "/checkout-sdk/static-3.23359",
  "checkout-service-types": "/checkout-service-types/static-1.3727",
  "company-details-components": "/company-details-components/static-1.6067",
  "payment-method-components": "/payment-method-components/static-1.6778",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.13113",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3362",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3407",
  "access-control-lib": "/access-control-lib/static-1.10318",
  "EmailComponents": "/EmailComponents/static-1.54391",
  "EmailData": "/EmailData/static-1.53068",
  "redux-less": "/redux-less/static-2.9366",
  "sequences-lib": "/sequences-lib/static-1.7830",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10229",
  "products-ui-components": "/products-ui-components/static-1.39604",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.80222",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6864",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54304",
  "commerce-products-api": "/commerce-products-api/static-1.2098",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56362",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.102179",
  "stripe-connect-js": "/stripe-connect-js/static-1.66",
  "draft-content-plugins": "/draft-content-plugins/static-1.27932",
  "ContentData": "/ContentData/static-1.67979",
  "layout-data-lib": "/layout-data-lib/static-1.9505",
  "outpost": "/outpost/static-1.4079",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.782",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "company-details-service-types": "/company-details-service-types/static-1.3810",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.3869",
  "account-and-billing-fintech-outages": "/account-and-billing-fintech-outages/static-3.18350",
  "pricing-pages-api": "/pricing-pages-api/static-1.12978",
  "ContentComponents": "/ContentComponents/static-2.70860",
  "marketing-contacts-lib": "/marketing-contacts-lib/static-1.9426",
  "marketing-email-service-types": "/marketing-email-service-types/static-1.1831",
  "messaging-editing-lib": "/messaging-editing-lib/static-1.45872",
  "messaging-usage-based-billing-components-lib": "/messaging-usage-based-billing-components-lib/static-1.734",
  "automation-ui-source-apps": "/automation-ui-source-apps/static-1.18481",
  "automation-ui-types": "/automation-ui-types/static-1.19399",
  "messaging-types-lib": "/messaging-types-lib/static-1.45609",
  "onboarding-settings-client": "/onboarding-settings-client/static-1.4385",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7687",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.399",
  "property-description-translator": "/property-description-translator/static-1.3735",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9042",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3537",
  "totals-ui-components": "/totals-ui-components/static-1.23219",
  "advanced-menus-core": "/advanced-menus-core/static-1.14937",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11903",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33688",
  "demographics-service-types": "/demographics-service-types/static-1.1529",
  "automation-ui-ubb": "/automation-ui-ubb/static-1.5315",
  "blueimp-md5": "/blueimp-md5/static-1.8",
  "content-embed-lib": "/content-embed-lib/static-1.7221",
  "data-token-views": "/data-token-views/static-1.16171",
  "forms-utils-lib": "/forms-utils-lib/static-1.12343",
  "payments-embed-points-lib": "/payments-embed-points-lib/static-1.12783",
  "simple-menus-core": "/simple-menus-core/static-1.14936",
  "simple-menus-lib": "/simple-menus-lib/static-1.16453",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4135",
  "videoconference-integration-components": "/videoconference-integration-components/static-1.6645",
  "automation-applications-service-types": "/automation-applications-service-types/static-1.3400",
  "automation-platform-service-types": "/automation-platform-service-types/static-1.2545",
  "ContentEditorUI": "/ContentEditorUI/static-2.76756",
  "short-messages-app-service-client": "/short-messages-app-service-client/static-1.3867",
  "web-interactives-components": "/web-interactives-components/static-1.13550",
  "web-interactives-data": "/web-interactives-data/static-1.13551",
  "messaging-shared-utils-lib": "/messaging-shared-utils-lib/static-1.183",
  "messaging-user-info-utils-lib": "/messaging-user-info-utils-lib/static-1.353",
  "email-portal-health-service-types": "/email-portal-health-service-types/static-1.857",
  "FireAlarmUi": "/FireAlarmUi/static-1.4410",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4068",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3717",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "automation-ui-core": "/automation-ui-core/static-2.21335",
  "automation-ui-usage-tracking": "/automation-ui-usage-tracking/static-1.20798",
  "data-studio-ubb": "/data-studio-ubb/static-1.2354",
  "backbone": "/backbone/static-1.6",
  "campaigns-lib": "/campaigns-lib/static-1.26655",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.57391",
  "content-management-data-lib": "/content-management-data-lib/static-1.5229",
  "copilot-plugins": "/copilot-plugins/static-1.10743",
  "cta-picker": "/cta-picker/static-1.36064",
  "customer-agent-discovery-components-lib": "/customer-agent-discovery-components-lib/static-1.2686",
  "editor-components": "/editor-components/static-1.13053",
  "editor-iframe-lib": "/editor-iframe-lib/static-1.8233",
  "error-messaging-js": "/error-messaging-js/static-1.5071",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85512",
  "pictos": "/pictos/static-7.181",
  "react-transition-group": "/react-transition-group/static-2.62",
  "redux-request-state": "/redux-request-state/static-1.10526",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1633",
  "smart-content-core": "/smart-content-core/static-1.42092",
  "smart-content-lib": "/smart-content-lib/static-1.42745",
  "social-composer-lib": "/social-composer-lib/static-1.58477",
  "structured-content-lib": "/structured-content-lib/static-1.24848",
  "theme-previewer-lib": "/theme-previewer-lib/static-1.52900",
  "tinymce-copilot": "/tinymce-copilot/static-1.16069",
  "xray-recommendation-lib": "/xray-recommendation-lib/static-1.7721",
  "automation-ui-routing": "/automation-ui-routing/static-1.20756",
  "sql-reporting-client-types": "/sql-reporting-client-types/static-1.5545",
  "jquery": "/jquery/static-3.6",
  "attribution-lib": "/attribution-lib/static-1.41868",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3038",
  "reporting-enablement": "/reporting-enablement/static-1.22406",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.20710",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.2188",
  "forms-ai-lib": "/forms-ai-lib/static-1.4127",
  "codemirror-dlb": "/codemirror-dlb/static-1.58315",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-undo": "/redux-undo/static-1.10",
  "seo-tools-lib": "/seo-tools-lib/static-1.6309",
  "report-customization-components": "/report-customization-components/static-1.12768",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12537",
  "html-to-image": "/html-to-image/static-1.51",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1334"
}
};
